import React from "react";
import { Link } from "react-router-dom";

export const TermsOfService = () => {
  return (
    <div>
      <nav style={{
        background: 'rgba(255, 255, 255, 0.95)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        padding: '20px 0',
        position: 'fixed',
        width: '100%',
        top: 0,
        zIndex: 1000
      }}>
        <div className="container">
          <Link 
            to="/" 
            style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#3b82f6',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <i className="fa-solid fa-arrow-left" style={{ marginRight: '8px' }}></i>
            Voltar para o site
          </Link>
        </div>
      </nav>

      <div id="terms-of-service" className="text-left" style={{ padding: '120px 0 80px', background: '#fff' }}>
        <div className="container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <div className="section-title" style={{ marginBottom: '40px' }}>
              <h2 style={{ textAlign: 'left' }}>Termos de Uso</h2>
              <p style={{ fontSize: '14px', color: '#64748b' }}>
                Última atualização: {new Date().toLocaleDateString('pt-BR')}
              </p>
            </div>

            <div style={{ lineHeight: '1.8' }}>
              <h3>1. Aceitação dos Termos</h3>
              <p>
                Ao acessar e usar o site da Cortex Prime Solutions ("Site"), você concorda em cumprir 
                e estar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte destes 
                termos, não deverá usar nosso Site ou serviços.
              </p>

              <h3>2. Sobre a Cortex Prime Solutions</h3>
              <p>
                <strong>Razão Social:</strong> [Inserir Razão Social Completa]<br />
                <strong>CNPJ:</strong> [Inserir CNPJ]<br />
                <strong>Endereço:</strong> [Inserir Endereço Completo]<br />
                <strong>E-mail:</strong> contato@cortexps.com.br<br />
                <strong>Telefone:</strong> +55 (48) 99822-7091
              </p>

              <h3>3. Serviços Oferecidos</h3>
              <p>
                A Cortex Prime Solutions é uma empresa de desenvolvimento de software e consultoria em TI 
                que oferece os seguintes serviços:
              </p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Desenvolvimento de software sob medida</li>
                <li>Consultoria em tecnologia da informação</li>
                <li>Manutenção e suporte de sistemas</li>
                <li>Integração de sistemas</li>
                <li>Testes e garantia de qualidade (QA)</li>
                <li>Migração de sistemas</li>
              </ul>

              <h3>4. Uso do Site</h3>
              <p>Ao usar nosso Site, você concorda em:</p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Fornecer informações verdadeiras e precisas</li>
                <li>Não usar o Site para fins ilegais ou não autorizados</li>
                <li>Não tentar obter acesso não autorizado a qualquer parte do Site</li>
                <li>Não transmitir vírus, malware ou qualquer código malicioso</li>
                <li>Não copiar, reproduzir ou distribuir conteúdo do Site sem autorização</li>
              </ul>

              <h3>5. Propriedade Intelectual</h3>
              <p>
                Todo o conteúdo deste Site, incluindo mas não limitado a textos, gráficos, logos, ícones, 
                imagens, clipes de áudio, downloads digitais e compilações de dados, é propriedade da 
                Cortex Prime Solutions ou de seus fornecedores de conteúdo e está protegido por leis 
                brasileiras e internacionais de direitos autorais.
              </p>

              <h3>6. Contratos de Serviço</h3>
              <p>
                Os serviços de desenvolvimento e consultoria oferecidos pela Cortex Prime Solutions são 
                regidos por contratos específicos que devem ser acordados entre as partes. Estes Termos 
                de Uso não constituem um contrato de prestação de serviços.
              </p>

              <h3>7. Orçamentos e Propostas</h3>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Orçamentos são válidos por 30 dias, salvo indicação em contrário</li>
                <li>Propostas comerciais têm caráter informativo até formalização contratual</li>
                <li>Valores estão sujeitos a alterações sem aviso prévio</li>
                <li>Prazos estimados dependem de validação técnica e aprovação do escopo</li>
              </ul>

              <h3>8. Confidencialidade</h3>
              <p>
                A Cortex Prime Solutions compromete-se a manter a confidencialidade de todas as informações 
                compartilhadas pelos clientes durante consultas, negociações e execução de projetos. 
                Acordos de Confidencialidade (NDA) específicos podem ser estabelecidos quando necessário.
              </p>

              <h3>9. Garantias e Limitações</h3>
              <p>
                <strong>9.1 Garantia de Serviços:</strong> Nossos serviços são fornecidos com garantia 
                de qualidade conforme especificado em cada contrato individual.
              </p>
              <p>
                <strong>9.2 Limitação de Responsabilidade:</strong> A Cortex Prime Solutions não será 
                responsável por:
              </p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Danos indiretos, incidentais ou consequenciais</li>
                <li>Perda de lucros, dados ou oportunidades de negócio</li>
                <li>Problemas causados por terceiros ou fatores fora de nosso controle</li>
                <li>Uso inadequado de software ou serviços fornecidos</li>
              </ul>

              <h3>10. Prazo e Rescisão</h3>
              <p>
                Projetos em andamento podem ser rescindidos conforme termos estabelecidos no contrato 
                específico. A rescisão unilateral sem justa causa pode implicar em multas contratuais 
                e pagamento pelos serviços já executados.
              </p>

              <h3>11. Suporte e Manutenção</h3>
              <p>
                Serviços de suporte e manutenção são oferecidos conforme acordado em contrato. O escopo, 
                SLA (Service Level Agreement) e custos são definidos individualmente para cada projeto.
              </p>

              <h3>12. Pagamento</h3>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Condições de pagamento são estabelecidas em cada contrato</li>
                <li>Atrasos podem resultar em juros e correção monetária</li>
                <li>Trabalho pode ser suspenso em caso de inadimplência</li>
                <li>Códigos-fonte e entregas finais são liberados após quitação total</li>
              </ul>

              <h3>13. Modificações do Site e Serviços</h3>
              <p>
                Reservamo-nos o direito de modificar ou descontinuar, temporária ou permanentemente, 
                o Site ou qualquer serviço sem aviso prévio. Não seremos responsáveis perante você ou 
                terceiros por qualquer modificação, suspensão ou descontinuação do Site.
              </p>

              <h3>14. Links para Sites de Terceiros</h3>
              <p>
                Nosso Site pode conter links para sites de terceiros. Não somos responsáveis pelo 
                conteúdo, políticas de privacidade ou práticas desses sites. Recomendamos que você 
                leia os termos e políticas de qualquer site de terceiros que visitar.
              </p>

              <h3>15. Isenção de Garantias</h3>
              <p>
                O Site é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo, 
                expressas ou implícitas, incluindo, mas não se limitando a garantias de comercialização, 
                adequação a um propósito específico ou não violação.
              </p>

              <h3>16. Lei Aplicável e Jurisdição</h3>
              <p>
                Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. 
                Qualquer disputa relacionada a estes termos será submetida à jurisdição exclusiva 
                dos tribunais brasileiros, com foro na comarca de [Inserir Cidade/Estado].
              </p>

              <h3>17. Alterações nos Termos</h3>
              <p>
                Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
                Alterações entram em vigor imediatamente após publicação no Site. O uso continuado 
                do Site após alterações constitui aceitação dos novos termos.
              </p>

              <h3>18. Disposições Gerais</h3>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Se qualquer disposição destes termos for considerada inválida, as demais permanecem em vigor</li>
                <li>A falha em exercer qualquer direito não constitui renúncia a esse direito</li>
                <li>Estes termos constituem o acordo integral entre você e a Cortex Prime Solutions</li>
              </ul>

              <h3>19. Contato</h3>
              <p>
                Para questões sobre estes Termos de Uso, entre em contato:
              </p>
              <p>
                <strong>Cortex Prime Solutions</strong><br />
                E-mail: contato@cortexps.com.br<br />
                Telefone: +55 (48) 99822-7091<br />
                Website: www.cortexps.com.br
              </p>

              <div style={{ 
                marginTop: '40px', 
                padding: '20px', 
                background: '#f8fafc', 
                borderRadius: '12px',
                borderLeft: '4px solid #3b82f6' 
              }}>
                <p style={{ margin: 0, fontSize: '14px' }}>
                  <strong>Importante:</strong> Ao usar nosso Site e serviços, você reconhece ter lido, 
                  compreendido e concordado com estes Termos de Uso e nossa Política de Privacidade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};
